import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import FullWidthPage from './FullWidthPage';
const useStyles = makeStyles((theme) => createStyles({
    container: ({ maxWidth }) => ({
        width: '100%',
        maxWidth: maxWidth - theme.spacing(6)
    })
}));
function LimitedWidthPage({ children, innerClass = '', maxWidth = 1200, ...props }) {
    const classes = useStyles({ maxWidth });
    const classNames = `${classes.container} ${innerClass}`;
    return (React.createElement(FullWidthPage, { ...props },
        React.createElement("div", { className: classNames }, children)));
}
export default LimitedWidthPage;
